<template>
    <div>
        <header-component :show_login_button = true :hide_points_msg = true></header-component>

        <component :is="innerWelcomeBannerComponent"></component>

        <div v-if="show_page_load_error" style="margin-top: 2rem;padding:2rem;text-align:center;color:red" > Failed to load offer details due to malformed link.  </div>
        <div class="shadow bg-white flexbox-container" v-if="this.mainOffer && this.mainOffer.OfferId" >

            <div class="flexbox-item flexbox-item-1">
               <img v-if="this.mainOffer && this.mainOffer.MerchantImageURL" class="logo_max_width" :src="this.mainOffer.MerchantImageURL"/>
            </div>

            <div class="flexbox-item flexbox-item-2">
               <div class="space_below">
                     <div class="title"  v-if="this.mainOffer && this.mainOffer.Merchant && this.mainOffer.Merchant.Name"> {{this.mainOffer.Merchant.Name}} </div>
                     <div class="cashback" v-if="this.mainOffer && this.mainOffer.Headline"> {{this.mainOffer.Headline }} </div>
               </div>
                <div>
                        <div class="redeem"> REDEEM </div>
                        <div class="rememptionType" v-if="this.mainOffer && this.mainOffer.RedemptionType">{{ this.mainOffer.RedemptionType }} </div>
                </div>
            </div>

            <div class="flexbox-item flexbox-item-3">
                <div class="space_below">
                    <a v-if="this.mainOffer.ActiveSc == 'AVAILABLE' && !this.activatedNow" @click="activateEmailOffer" :disabled="activating" :class="(activating) ? 'button pink midsize mid me-3 isDisabled' : 'button pink midsize mid me-3'" >{{this.activating ? 'Activating' : 'Activate'}}</a>
                    <a v-if="this.mainOffer.ActiveSc != 'AVAILABLE' || this.activatedNow" href="javascript:"  class="button activated pink midsize mid me-3">Activated</a>
               </div>
                <div>
                    <div  class="redeem"> EXPIRES </div>
                    <div class="rememptionType"  v-if="this.mainOffer.EventEndDate && isNaN(this.mainOffer.EventEndDate)">{{formattedEndDate }} </div>
                </div>
            </div>
        </div>

        <div :class="this.mainOffer && this.mainOffer.OfferId && this.bcn ? 'error_msg_with_offer': 'error_msg_with_out_offer'" v-if="show_offer_activation_failed_msg"> {{show_offer_activation_failed_msg}}</div>

        <div v-if="this.mainOffer && this.mainOffer.LongDescription" class="copy-area">
            <h4>Offers details</h4>
            <div><p>{{this.mainOffer.LongDescription}}</p></div>
        </div>
        <div v-if="this.mainOffer && this.mainOffer.DetailedTerms || this.mainOffer.LongTerms" class="copy-area">
            <h4>TERMS & CONDITIONS</h4>
            <div>
                <p v-if="this.mainOffer.DetailedTerms">{{this.mainOffer.DetailedTerms}}</p>
                <p v-if="this.mainOffer.LongTerms">{{this.mainOffer.LongTerms}}</p>
            </div>
        </div>
        <div v-if="this.mainOffer && this.mainOffer.OfferId" class="copy-area">
            <a v-if="this.mainOffer.ActiveSc == 'AVAILABLE' && !this.activatedNow" @click="activateEmailOffer" :disabled="activating" :class="(activating) ? 'button pink midsize mid me-3 isDisabled' : 'button pink midsize mid me-3'" >{{this.activating ? 'Activating' : 'Activate'}}</a>
            <a v-if="this.mainOffer.ActiveSc != 'AVAILABLE' || this.activatedNow" href="javascript:"  class="button activated pink midsize mid me-3">Activated</a>
            <div class="show_second_error" style="text-align: center;color:red;padding:2rem;font-size:2rem" v-if="show_offer_activation_failed_msg"> {{show_offer_activation_failed_msg}}</div>
        </div>


        <div v-if="this.mainOffer && this.mainOffer.OfferId" class="personalized_offers">
        <div class="copy-area">
            <h4 style="padding-top: 5rem">Add more personalized offers curated just for you</h4>
            <div class="article-detais-view">
                <offers-block-component
                    v-for="(item, index) in this.matchedOffers"
                    :key="item.OfferId"
                    :offer="item"
                    :email_offer_activation="true"
                    :bcn="bcn"
                    @activateEmailOffer = "activateEmailOffer"
                >
                </offers-block-component>
            </div>
              <div style="display:flex; justify-content: center">
                  <button style="padding:1rem" v-if="this.showNext"
                          @click="next"> Show more </button>
              </div>
        </div>
        </div>



        <!-- Footer -->
        <footer-component>
            <template v-slot:after-links v-if="showPromotionalBanner">
                <post-login-disclosure />
            </template>
        </footer-component>
    </div>
</template>

<script>
    import moment from "moment";
    import InnerWelcomeBannerPromotionComponent from "../banners/InnerWelcomeBannerPromotionComponent.vue";
    import InnerWelcomeBannerComponent from "../banners/InnerWelcomeBannerComponent.vue";
    import PostLoginDisclosure from "../promotions/PostLoginDisclosure.vue";
    // import InnerWelcomeBannerComponent from "./../InnerWelcomeBannerComponent.vue";
    // import FooterComponent from "./../FooterComponent.vue";
    // import HeaderComponent from "./../HeaderComponent.vue";
    export default {
        name: "EmailOfferLandingComponent",
        components: {PostLoginDisclosure},
        data () {
            return {
                matchedOffers: [],
                mainOffer: [],
                loading: false,
                showNext: false,
                pageNumber: 1,
                bcn:null,
                activating: false,
                activatedNow: false,
                show_offer_activation_failed_msg: false,
                show_page_load_error: false,
                showPromotionalBanner: window.appGlobalData.showPromotionalBanner,
                innerWelcomeBannerComponent : window.appGlobalData.showPromotionalBanner?InnerWelcomeBannerPromotionComponent:InnerWelcomeBannerComponent
            }
    },
        methods: {
            getOffers(payload) {

                this.loading = true;

                axios.post(this.apiEndPoints.getMatchedOfferForEmailActivation, payload)
                    .then((response) => {
                        let offers = response?.data?.Response?.Items?.MatchedOffer;

                        if(payload.OffersList) { // we are getting offer from url params

                            if (offers !== undefined && offers.length == 1 && offers[0].OfferId == this.$route.query.offer_id) {

                                this.mainOffer = offers[0];

                                if(offers[0].ActiveSc == 'AVAILABLE' && this.$route.query.mode != 'view') {
                                    /**
                                     * fire activation
                                     */
                                    this.activateEmailOffer();
                                }

                            } else if (response.data && response.data.message) {
                                this.show_offer_activation_failed_msg = response.data.message;
                            } else {
                                this.show_offer_activation_failed_msg = 'Could not identify offer in the system. Please try again later.';
                            }
                        } else {
                            let currentPage = response?.data?.Response?.CurrentPage;
                            let noOfPages = response?.data?.Response?.NumberOfPages;

                            if (noOfPages > currentPage) {
                                this.showNext = true;
                            } else {
                                this.showNext = false;
                            }

                            if (offers !== undefined) {
                                if (this.pageNumber > 1) {
                                    let currentOffers = this.matchedOffers;
                                    this.matchedOffers = {...currentOffers, ...offers};
                                } else {
                                    this.matchedOffers = {...offers};
                                }
                            }
                        }
                    })
                    .catch((error) => {
                        // console.error(error, 'here');
                        // console.error(error.status,'here')
                        if (error.response.status == 401 || error.response.status == 419) {
                            location.reload();
                             // this.$router.push({name: 'sign_in'});
                        }
                    }).finally(() => {
                    this.loading = false;
                });
            },
            next() {
                this.pageNumber = this.pageNumber + 1;
                let payload = {
                    PageNumber: this.pageNumber,
                    ItemsPerPage: 8,
                    getOffersForEmailActivation: 1,
                    offer_id: this.$route.query.offer_id,
                    bcn: this.$route.query.bcn
                };

                this.getOffers(payload);
            },
            activateEmailOffer() {
                /**
                 * finally fire a call to activate the offer
                 */
                this.activating = true;
                this.show_offer_activation_failed_msg = false;
                axios.post(this.apiEndPoints.emailActivateOffer, {
                    offer_id: this.$route.query.offer_id,
                    bcn: this.$route.query.bcn,
                    offer_provider: this.mainOffer.OfferProvider
                }).then(response => {
                    if (response.data && response.data.ActivationId) {
                        if(response.data.Status && response.data.Status == 'ACTIVATED') {
                            this.activatedNow = true;
                            this.mainOffer.EventEndDate = response.data.RedemptionEndDate;
                        } else {
                            this.activatedNow = false;
                        }
                    } else if (response.data && response.data.message) {
                            this.show_offer_activation_failed_msg = response.data.message;
                    } else {
                        this.show_offer_activation_failed_msg = 'Offer activation failed. Please try again later.';
                    }
                }).catch(error => {
                    this.show_offer_activation_failed_msg = 'Offer activation failed. Please try again later.';

                    if (error.response && error.response.data && error.response.data.message) {
                        this.show_offer_activation_failed_msg = error.response.data.message;
                    }
                    if (error.response && error.response.status && (error.response.status == 401 || error.response.status == 419)) {
                      //  this.$router.push("sign_in");
                        location.reload();
                    }

                    return false;
                }).finally(() => {
                    this.activating = false;
                });
            }
        },
        computed: {
            formattedEndDate() {
                return (this.mainOffer && this.mainOffer.EventEndDate) ? moment(this.mainOffer.EventEndDate).format('MM-DD-YYYY') : '';
            }
        },
        mounted() {

           if(this.$route.query.bcn && this.$route.query.offer_id) {

               this.bcn = this.$route.query.bcn;
               /**
                * first get the offer details
                */
               let payload_1 = {
                   PageNumber: 1,
                   ItemsPerPage: 1,
                   getOffersForEmailActivation: 1,
                   offer_id: this.$route.query.offer_id,
                   bcn: this.$route.query.bcn,
                   OffersList: [this.$route.query.offer_id]
               };

               this.getOffers(payload_1);


               /**
                * second get the personalized offer
                */

               let payload_2 = {
                   PageNumber: this.pageNumber,
                   ItemsPerPage: 8,
                   getOffersForEmailActivation: 1,
                   offer_id: this.$route.query.offer_id,
                   bcn: this.$route.query.bcn,
               };

               this.getOffers(payload_2);

           } else {
               this.show_page_load_error = true;
            }
        }
    }
</script>

<style scoped>

    .error_msg_with_offer {
        display: flex;justify-content: center;color:red; margin-top:-2rem; margin-bottom: 2rem; font-size:2rem
    }

    .error_msg_with_out_offer {
        display: flex;justify-content: center;color:red; margin: 2rem; font-size:2rem
    }
    .flexbox-container{
        display: flex;
        justify-content:space-around;
        align-items: center;
        margin: -2rem auto 6rem;
        width: 50%;
        border-radius:1.4rem;
        padding: 3rem
    }

    .flexbox-item{
        padding: 2rem;
    }

    .title{
        font-size: 1.5rem;
        color: #333333;
        margin-bottom: 0.5rem;
    }

    .redeem{
        font-size: 1.2rem;
        color: #333333;
        margin-bottom: 0.5rem;
    }

    .logo_max_width{
        max-width: 230px;
    }

    .cashback{
        font-size: 2.5rem;
        color: black;
    }

    .rememptionType{
        font-size: 2rem;
        color: black;
    }

    .space_below{
        margin-bottom: 1.5rem;
    }

    .copy-area{
        width: 70%;
        margin-left: 15%;
        padding: 1.5rem 0
    }

    .isDisabled {
        pointer-events: none;
    }
    .personalized_offers{
        background-color: #fafcff;
    }
    p{ font-size: 2rem;  margin-bottom: 1rem; line-height: 1.3;}
    h4{ font-size: 2.4rem; margin-bottom: 1rem;}

    .show_second_error {
        display: none;
    }
    @media screen and (max-width: 700px){
        .flexbox-container{
            display: flex;
            flex-direction: column;
            justify-content:space-around;
            align-items: center;
            margin: -2rem auto 6rem;
            width: 90%;
            border-radius:1.4rem;
            padding: 3rem
        }

        .show_second_error {
            display: block;
        }

        .copy-area a {
            display: flex;
            justify-content:center;
        }

    }

</style>
